import React, { useEffect } from 'react'

import { Select } from '@driftt/tide-selects'

import CheckboxRow from './CheckboxRow'

import styles from '../styles.module.css'

const SelectCheckboxRow: React.FC<any> = ({
  options,
  label,
  field,
  form,
  useFirst = true,
  ...rest
}) => {
  const { setFieldValue } = form

  useEffect(() => {
    if (field.value === true) {
      const valToUse = useFirst ? options[0].value : null
      setFieldValue(field.name, valToUse)
    } else if (field.value === 'nothing') {
      setFieldValue(field.name, false)
    }
  }, [field.value, setFieldValue, options, field.name, useFirst])

  const value = options.find((opt: any) => opt.value === field.value)

  return (
    <CheckboxRow
      {...rest}
      field={field}
      form={form}
      content={
        <div>
          <div>{label}</div>
          <div>
            <Select
              className={styles.select}
              isSearchable={false}
              size={'small'}
              value={value ?? null}
              onChange={({ value }: any) => form.setFieldValue(field.name, value)}
              placeholder="Select...."
              options={options}
              isDisabled={!field.value}
            />
          </div>
        </div>
      }
    />
  )
}

export default SelectCheckboxRow
